var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        top: "",
        "offset-y": "",
        "min-width": "290px",
        origin: "left bottom",
        transition: "scale-transition",
        "close-on-content-click": false
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-text-field",
                _vm._g(
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      dense: "",
                      filled: "",
                      readonly: "",
                      required: "",
                      clearable: "",
                      name: "time",
                      "data-vv-as": "horário",
                      "prepend-inner-icon": "mdi-clock-outline",
                      label: "Selecione o horário à ser enviado",
                      value: _vm.time,
                      error: _vm.errors.has("time"),
                      "error-messages": _vm.errors.first("time")
                    },
                    on: { input: _vm.setTime }
                  },
                  on
                )
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.menu,
        callback: function($$v) {
          _vm.menu = $$v
        },
        expression: "menu"
      }
    },
    [
      _vm._v(" "),
      _vm.menu
        ? _c("v-time-picker", {
            attrs: { format: "24hr", color: "primary", value: _vm.time },
            on: {
              "click:minute": function($event) {
                _vm.menu = false
              },
              input: _vm.setTime
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45e4e99e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45e4e99e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/Send/Steps/Scheduling/TimePicker.vue
// module id = null
// module chunks = 